// extracted by mini-css-extract-plugin
export default {"wrapper":"share-module--wrapper--4NRgB","item":"share-module--item--3Ull8","button":"share-module--button--8eoxr"};